import { useMediaQuery } from '@mui/material';

const useIsMobile = (size = 'md') => useMediaQuery((theme) => theme.breakpoints.down(size));

export default useIsMobile;
